import { render } from "./ContatoPage.vue?vue&type=template&id=5b0cb2dc&scoped=true"
import script from "./ContatoPage.vue?vue&type=script&lang=js"
export * from "./ContatoPage.vue?vue&type=script&lang=js"

import "./ContatoPage.vue?vue&type=style&index=0&id=5b0cb2dc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b0cb2dc"]])

export default __exports__